<template>
  <div class="productSelection">
    <el-tabs v-model="dataForm.status" @tab-click="resetPage" class="w-full">
      <el-tab-pane
        v-for="(item, index) in inquiryStatusList"
        :label="`${item.label}(${item.count})`"
        :name="item.value"
        :key="'tab_' + index"
      ></el-tab-pane>
    </el-tabs>
    <el-form :inline="true" :model="dataForm">
      <el-form-item label="选型询价单号：">
        <el-input
          v-model.trim="dataForm.lectotypeInquiryNo"
          placeholder="选型询价单号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker
          v-model="dataForm.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="shortcuts"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList()"
          >查询</el-button
        >
        <el-button class="butt" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      max-height="500px"
      key="inquiryTable"
      v-loading="dataLoading"
      border
    >
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无相关询价单" />
        <div>暂无数据</div>
      </div>
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
        label="序号"
      >
        <template slot-scope="scope">
          {{ (dataForm.page - 1) * dataForm.limit + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="lectotypeInquiryNo"
        header-align="center"
        align="center"
        label="选型询价单号"
      >
        <template slot-scope="scope">
          <a href="javascript:;" @click="toDetail(scope.row)">
            {{ scope.row.lectotypeInquiryNo }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        label="状态"
        width="100px"
      >
        <template slot-scope="scope">
          {{ getStatusLabel(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createUserName"
        header-align="center"
        align="center"
        label="发起人"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="创建时间"
        width="155px"
      ></el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="选型备注"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="操作"
        width="110"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="onCancel(scope.row)"
            v-if="scope.row.status == 0"
            >取消</el-button
          >
          <!-- 只在已报价时展示 -->
          <el-button
            type="text"
            size="small"
            @click="toDetail(scope.row)"
            v-if="[2, 7].includes(+scope.row.status) && scope.row.quoteNumber"
          >
            去确认</el-button
          >
          <!-- 部分确认或者全部确认且未全部下单的单据有去下单按钮 -->
          <el-button
            type="text"
            size="small"
            @click="toSubmit(scope.row)"
            v-if="[3, 7, 9].includes(+scope.row.status)"
          >
            去下单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="dataForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="dataForm.limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
    <el-dialog
      :visible.sync="cancelTip.visible"
      title="提示"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="480px"
    >
      <h3>将会取消整单需求，请再次确认是否继续执行该操作！</h3>
      <template slot="footer">
        <el-button @click="cancelTip.visible = false">取消</el-button>
        <el-button type="primary" @click="submitCancel">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { shortcuts } from '@/utils/shortcuts'
const Base64 = require('js-base64').Base64
export default {
  name: 'productSelection', // 询价列表页
  data () {
    return {
      shortcuts: { shortcuts },
      dataLoading: false,
      inquiryStatusList: [
        // 0待受理 1处理中 2已报价 3全部确认 4全部拒绝 5已取消 6不受理 7部分确认 9部分转单 10全部转单
        {
          value: 'all',
          label: '全部',
          count: 0
        },
        {
          value: '0',
          label: '待受理',
          count: 0
        },
        {
          value: '1,8',
          label: '处理中',
          count: 0
        },
        {
          value: '2',
          label: '已报价',
          count: 0
        },
        {
          value: '3',
          label: '全部确认',
          count: 0
        },
        {
          value: '7',
          label: '部分确认',
          count: 0
        },
        {
          value: '4',
          label: '全部拒绝',
          count: 0
        },
        {
          value: '5',
          label: '已取消',
          count: 0
        },
        {
          value: '6',
          label: '不受理',
          count: 0
        },
        {
          value: '9',
          label: '部分转单',
          count: 0
        },
        {
          value: '10',
          label: '全部转单',
          count: 0
        }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        time: null,
        status: 'all',
        lectotypeInquiryNo: ''
      },
      total: 0,
      dataList: [],
      // countObj: {},
      cancelTip: {
        data: null,
        visible: false
      }
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    toDetail (data) {
      window.open(
        `${
          window.location.origin
        }/personalCenter/productSelectionDetail?id=${Base64.encode(data.id)}`
      )
    },
    // 去下单
    toSubmit (row) {
      // 查询所有待下单的数据
      const obj = {
        page: 1,
        limit: 999,
        lectotypeInquiryNo: row.lectotypeInquiryNo,
        recordStatusList: [3]
      }
      this.$http
        .post(`/front/commodity/web/lectotypeInquiry/record/listByPage`, obj)
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            const shoppingCartFormList = []
            data.dataList.forEach((item) => {
              shoppingCartFormList.push({
                goodsSpuId: item.skuSpuId,
                goodsSkuId: item.skuId,
                goodsNum: item.number,
                sellingPrice: item.quotePrice,
                moq: item.moq || undefined
              })
            })

            const t = new Date().getTime()
            const obj = {
              t,
              orderSource: '10',
              shoppingCartFormList: shoppingCartFormList
            }
            sessionStorage.setItem('createOrder', JSON.stringify(obj))
            this.$router.push({
              name: 'createOrder',
              query: {
                lectotypeInquiryNo: row.lectotypeInquiryNo,
                t
              }
            })
          }
        })
    },
    onCancel (data) {
      this.cancelTip.data = data
      this.cancelTip.visible = true
    },
    submitCancel () {
      const obj = {
        id: this.cancelTip.data.id,
        status: 5
      }
      const that = this
      this.$http
        .post(`/front/commodity/manager/lectotypeInquiry/updateStatus`, obj)
        .then(({ data: { code } }) => {
          if (code === 0) {
            that.$message({
              message: '操作成功',
              type: 'success'
            })
            that.getDataList()
            that.cancelTip.visible = false
          }
        })
    },
    reset () {
      this.dataForm.lectotypeInquiryNo = ''
      this.dataForm.time = null
      this.getDataList()
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList()
    },
    // 当前页
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getDataList()
    },
    resetPage () {
      console.log(this.dataForm)
      this.dataForm.page = 1
      this.getDataList()
    },
    getDataList () {
      const statusList =
        this.dataForm.status === 'all'
          ? []
          : this.dataForm.status.includes(',')
            ? this.dataForm.status.split(',')
            : [this.dataForm.status]
      const [createTimeStart, createTimeEnd] = this.dataForm.time || []
      const obj = {
        page: this.dataForm.page,
        limit: this.dataForm.limit,
        createUserId: this.$store.state.user.id,
        createTimeStart: createTimeStart ? createTimeStart + ' 00:00:00' : null,
        createTimeEnd: createTimeEnd ? createTimeEnd + ' 23:59:59' : null,
        lectotypeInquiryNo: this.dataForm.lectotypeInquiryNo,
        statusList
      }
      const that = this
      this.getCount(obj)
      this.$http
        .post(`/front/commodity/web/lectotypeInquiry/listByPage`, obj)
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            // console.log(data)
            that.dataList = data.dataList || []
            that.total = +data.count
          }
        })
    },
    getCount (obj) {
      const that = this
      const param = { ...obj }
      Reflect.deleteProperty(param, 'statusList')
      this.$http
        .post(
          `/front/commodity/manager/lectotypeInquiry/queryCountByStatus`,
          param
        )
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            console.log(data);
            // that.countObj = data;
            [
              'total',
              'dsl',
              'clz,yxj',
              'ybj',
              'qbqr',
              'bfqr',
              'qbjj',
              'qx',
              'bsl',
              'bfzd',
              'qbzd'
            ].forEach((k, i) => {
              if (k.includes(',')) {
                let count = 0
                k.split(',').forEach((item) => {
                  count += data[item]
                })
                that.inquiryStatusList[i].count = count
              } else {
                that.inquiryStatusList[i].count = data[k]
              }
            })
          }
        })
    },
    getStatusLabel (val) {
      if (!val && val !== 0) {
        return '-'
      }
      const item = this.inquiryStatusList.find((i) => {
        if (i.value.includes(',')) {
          return i.value.split(',').includes(val + '')
        } else {
          return i.value === val + ''
        }
      })
      if (!item.label) {
        return '-'
      } else {
        return item.label
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.productSelection {
  .w-full {
    width: 100%;
  }
}
</style>
